import React from 'react';
import { Layout, Text, useTheme } from '@ui-kitten/components';
import { Q_GET_CAMPAIGN } from '../../data/api/query/q_campaigns';
import { useQuery } from '@apollo/react-hooks';
import { AuthContext } from '../../App';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { CampaignList } from '../../components/campaigns/campaignList';





export default function CampaignScreen({ navigation, route }): React.ReactElement {
    const MAIN_COLOR: string = useTheme()['color-primary-default'];
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = useScreenDimensions();
    const { pageSpacerHorizontal } = getItemWidth({ isMediumScreenOrLarger, isLargeScreenOrLarger });
    const params = route?.params;
    console.log({ navigation, route, params });
    const { user } = React.useContext(AuthContext);
    const { loading, error, data, refetch } = useQuery(Q_GET_CAMPAIGN, { fetchPolicy: 'network-only' });


    if (loading) {
        return <PageLoadingIndicator />;
    };
    if (error) {
        console.log(error);
        return <Text onPress={refetch}>Error :(</Text>;
    };
    console.log('we have data, ', data)


    return (
        <Layout level='3' style={{ flex: 1 }}>
            <CampaignList
                data={data}
                navigation={navigation}
                pageSpacerHorizontal={pageSpacerHorizontal}
                product_plan_title={user ? user.product_plan.title : undefined}
                highlightColor={MAIN_COLOR}
            />
        </Layout>
    );
}